import { useEffect, useRef, useState } from 'react'
import CLOUDS from 'vanta/dist/vanta.clouds.min'
import * as THREE from 'three'
import NavBar from './components/Sidebar'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import Portfolio from './components/Portfolio'
import './App.scss'

function App() {
  const [vantaEffect, setVantaEffect] = useState(null)
  const vantaRef = useRef(null)

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        CLOUDS({
          el: vantaRef.current,
          THREE,
          skyColor: 0xc3b1e1,
          cloudColor: 0xece9f6,
          speed: 0.7,
          backgroundAlpha: 1,
        })
      )
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy()
    }
  }, [vantaEffect])

  return (
    <>
      <div className="vanta-bg" ref={vantaRef} />
      <div className="vanta-overlay" />
      <div className="app-content">
        <NavBar />
        <main>
          <Home />
          <About />
          <Portfolio />
          <Contact />
        </main>
      </div>
    </>
  )
}

export default App
